import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import VScroll_Item from '../_app/cuchillo/scroll/VScroll_Item';
import { SliderHorizontalScroll } from '../_app/cuchillo/components/SliderHorizontalScroll';
import { ScrollItem__Default } from './ScrollItem__Default';
import { isMobile } from '../_app/cuchillo/core/Basics';

class ScrollItem__SliderScrollHorizontal extends VScroll_Item {
  _slider;

  //==================================================================================================================
  //          CONSTRUCTOR
  //==================================================================================================================

  constructor(__link, __index, __scroller) {
    super(__link, __index, __scroller);

    if (!isMobile) {
      this._slider = new SliderHorizontalScroll(__link,
        {
          interaction: false,
          hasLimits: false,
          scrollbar: true,
          itemClass: SliderScroll__Horizontal__Item
        });
    }

    this.onShow = () => {
      if (this._slider) this._slider.show();
    };
    this.onHide = () => { };
    this.onMove = () => {
      if (this._slider) {
        this._slider.progress = 1 - this.progressInside;
        this._slider.loop();
      }
    }
  }

  //==================================================================================================================
  //          PUBLIC
  //==================================================================================================================

  dispose() {
    super.dispose();
    if (this._slider) this._slider.dispose();
  }

  resize(__w, __h) {
    super.resize(__w, __h);
  }
}

Scroll._registerClass('slider-horizontal-scroll', ScrollItem__SliderScrollHorizontal);

class SliderScroll__Horizontal__Item extends ScrollItem__Default {
  //==================================================================================================================
  //          CONSTRUCTOR
  //==================================================================================================================
  constructor(__link, __index, __scroller) {
    super(__link, __index, __scroller);
  }

  //==================================================================================================================
  //          PUBLIC
  //==================================================================================================================
  mouseOver() { }
  mouseDown() { }
  mouseUp() { }
}
